import React, { useState } from "react";
import { Button } from "./ui/button";
import { Menu, X } from "lucide-react";
import Logo from "../assets/quillstudio-logo.png";

const Header = () => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    }
    setIsMobileMenuOpen(false);
  };

  return (
    <header className="sticky top-0 z-50 bg-white/80 backdrop-blur-md border-b border-slate-200/50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-16">
          {/* Logo */}
          <div className="flex items-center space-x-3">
            <img 
              src={Logo} 
              alt="QuillStudio Logo" 
              className="h-60 w-60 object-contain" 
            />
          </div>
          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center space-x-8">
            <button
              onClick={() => scrollToSection("features")}
              className="text-slate-600 hover:text-slate-900 transition-colors duration-200 font-medium"
            >
              Features
            </button>
            <button
              onClick={() => scrollToSection("how-it-works")}
              className="text-slate-600 hover:text-slate-900 transition-colors duration-200 font-medium"
            >
              How It Works
            </button>
            <button
              onClick={() => scrollToSection("benefits")}
              className="text-slate-600 hover:text-slate-900 transition-colors duration-200 font-medium"
            >
              Benefits
            </button>
            <button
              onClick={() => scrollToSection("pricing")}
              className="text-slate-600 hover:text-slate-900 transition-colors duration-200 font-medium"
            >
              Pricing
            </button>
            <Button 
              className="bg-gradient-to-r from-orange-500 to-pink-500 hover:from-orange-600 hover:to-pink-600 text-white px-6 py-2 transition-all duration-200 transform hover:scale-105"
              onClick={() => window.open('https://appexchange.salesforce.com', '_blank')}
            >
              Get on AppExchange
            </Button>
          </nav>

          {/* Mobile Menu Button */}
          <button
            className="md:hidden p-2 rounded-lg hover:bg-slate-100 transition-colors duration-200"
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
          >
            {isMobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>

        {/* Mobile Menu */}
        {isMobileMenuOpen && (
          <div className="md:hidden py-4 border-t border-slate-200/50 bg-white/95 backdrop-blur-sm">
            <nav className="flex flex-col space-y-3">
              <button
                onClick={() => scrollToSection("features")}
                className="text-left text-slate-600 hover:text-slate-900 transition-colors duration-200 font-medium py-2"
              >
                Features
              </button>
              <button
                onClick={() => scrollToSection("how-it-works")}
                className="text-left text-slate-600 hover:text-slate-900 transition-colors duration-200 font-medium py-2"
              >
                How It Works
              </button>
              <button
                onClick={() => scrollToSection("benefits")}
                className="text-left text-slate-600 hover:text-slate-900 transition-colors duration-200 font-medium py-2"
              >
                Benefits
              </button>
              <Button 
                className="bg-gradient-to-r from-orange-500 to-pink-500 hover:from-orange-600 hover:to-pink-600 text-white w-full mt-4 transition-all duration-200"
                onClick={() => window.open('https://appexchange.salesforce.com', '_blank')}
              >
                Get on AppExchange
              </Button>
            </nav>
          </div>
        )}
      </div>
    </header>
  );
};

export default Header;